

window.timber = window.timber || {};

timber.cache = {
  // General
  html: $('html'),
  body: $('body'),

  // Product Page
  mainImage: $('#productPhotoImg'),
  thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
  newImage: null
}

timber.init = function () {
  timber.cache.html.removeClass('no-js').addClass('js');

  // Run on load
  timber.productImageSwitch();
}

timber.productImageSwitch = function () {
  if ( !timber.cache.thumbImages.length ) {
    return;
  }

  // Switch the main image with one of the thumbnails
  // Note: this does not change the variant selected, just the image
  timber.cache.thumbImages.on('click', function(e) {
    e.preventDefault();
    timber.cache.newImage = $(this).attr('href');
    timber.cache.mainImage.attr({ src: timber.cache.newImage });
    $('#productPhoto').trigger('zoom.destroy');
    $('#productPhoto').zoom({ magnify:'1.5' });
  });
}

// Initialize Timber's JS on docready
$(function() {
  
  $('.fancybox').fancybox();

  window.timber.init();

  $(window).load(function() {

        $('.flexslider').flexslider({
            animation: "slide",
            directionNav: false
        });

        $('#productPhoto').zoom({ magnify:'1.5' });

    });

});
